module.exports = __webpack_public_path__ + "static/media/cv3.e5311607.png";